import { ADD_PERSON } from "../constant";

export const addPersonAction = (data) => ({ type: ADD_PERSON, data });

